import React from 'react';
import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography,
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { useDroppable } from '@dnd-kit/core';
import { getFolderName } from '../../../../utils/getFolderName';

function DroppableCrumb({ crumb, onBreadcrumbClick, canDrop }) {
  const dropId = `breadcrumb:${crumb.id ?? 'root'}`;
  const { setNodeRef, isOver } = useDroppable({ id: dropId, disabled: !canDrop });
  const displayName = crumb.id === null ? crumb.name : getFolderName(crumb.name);

  return (
    <Link
      ref={setNodeRef}
      component="button"
      variant="body2"
      onClick={() => onBreadcrumbClick(crumb)}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 0.5,
        px: 0.5,
        transition: 'background-color 0.15s',
        backgroundColor: isOver ? 'action.selected' : 'transparent',
        outline: isOver ? '2px solid' : 'none',
        outlineColor: 'primary.main',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {crumb.id === null && <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />}
      {displayName}
    </Link>
  );
}

export function BreadcrumbNavigation({
  breadcrumbs,
  onBreadcrumbClick,
  canDrop = false,
}) {
  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const displayName = crumb.id === null ? crumb.name : getFolderName(crumb.name);

          if (isLast) {
            return (
              <Box key={crumb.id || 'root'} display="flex" alignItems="center">
                {crumb.id === null && <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />}
                <Typography variant="body2">{displayName}</Typography>
              </Box>
            );
          }

          return (
            <DroppableCrumb
              key={crumb.id || 'root'}
              crumb={crumb}
              onBreadcrumbClick={onBreadcrumbClick}
              canDrop={canDrop}
            />
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
}
